module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "font-size": ".9em"
    },
    attrs: {
      "id": "copy"
    }
  }, [_c('p', {
    staticClass: "CC"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("© 2024 David P. Kavanaugh")])]), _vm._v(" "), _c('p', {
    staticClass: "CC"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any manner without written permission except in the case of brief quotations embodied in critical articles or reviews.")])]), _vm._v(" "), _c('p', {
    staticClass: "CC"
  }, [_c('span', {
    staticClass: "Italics CharOverride-5"
  }, [_vm._v("Dinky Donkey Doo")])]), _vm._v(" "), _c('p', {
    staticClass: "CC0"
  }, [_c('span', {
    staticClass: "Italics CharOverride-5"
  }, [_vm._v("A Brave Boy, His Loyal Protector, and a Journey of Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "CC"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Brown Books Kids")])]), _vm._v(" "), _c('p', {
    staticClass: "CC0"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("16250 Knoll Trail Drive, Suite 250")])]), _vm._v(" "), _c('p', {
    staticClass: "CC0"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Dallas, Texas 75248")])]), _vm._v(" "), _c('p', {
    staticClass: "CC0"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_c('a', {
    attrs: {
      "href": "http://www.BrownBooksKids.com",
      "target": "_blank"
    }
  }, [_vm._v("www.BrownBooksKids.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC0"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("(972) 381-0009")])]), _vm._v(" "), _c('p', {
    staticClass: "CC"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("A New Era in Publishing®")])]), _vm._v(" "), _c('p', {
    staticClass: "CC"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Publisher’s Cataloging-In-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "CC ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Names: Kavanaugh, David P., author. | Arrayás, Albert, 1990 - illustrator.")])]), _vm._v(" "), _c('p', {
    staticClass: "CC0 ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Title: Dinky Donkey Doo : A Brave Boy, His Loyal Protector, and a Journey of Hope / David P. Kavanaugh ; [illustrated by Albert Arrayás].")])]), _vm._v(" "), _c('p', {
    staticClass: "CC0 ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Description: Dallas, Texas : Brown Books Kids, [2024] | Interest age level: 007-011. | Summary: When Jack has a hard time healing from a fall, he goes to the hospital and finds out that he has leukemia, a cancer of the blood. Though his family and his doctors are all there for him, Jack misses being able to visit the farm. That’s when a donkey named Dinky Donkey Doo comes to stay at his house! Over three years, Jack battles cancer with Dinky right by his side, providing support and lifelong memories to make the battle a little less scary each day.--Publisher.")])]), _vm._v(" "), _c('p', {
    staticClass: "CC0 ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Identifiers: ISBN: 978-1-61254-671-1 (paperback) | 978-1-61254-672-8 (ePub) | LCCN: 2024943445")])]), _vm._v(" "), _c('p', {
    staticClass: "CC0 ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Subjects: LCSH: Cancer in children--Juvenile fiction. | Leukemia in children--Juvenile fiction. | Hospital patients--Juvenile fiction. | Donkeys--Therapeutic use--Juvenile fiction. | Human-animal relationships--Juvenile fiction. | Friendship--Juvenile fiction. | CYAC: Cancer--Fiction. | Leukemia--Fiction. | Donkeys--Fiction. | Human-animal relationships--Fiction. | Friendship-- Fiction. | BISAC: JUVENILE FICTION / Health & Daily Living / Diseases, Illnesses & Injuries. | JUVENILE FICTION / Social Themes / Friendship. | JUVENILE FICTION / Animals / Farm Animals.")])]), _vm._v(" "), _c('p', {
    staticClass: "CC0 ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Classification: LCC: PZ7.1.K383 Di 2024 | DDC: [Fic]--dc23")])]), _vm._v(" "), _c('p', {
    staticClass: "CC"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("This book has been officially leveled by using the F&P Text Level Gradient")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("TM")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Leveling System.")])]), _vm._v(" "), _c('p', {
    staticClass: "CC"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("ISBN 978-1-61254-671-1"), _c('br'), _vm._v("EISBN 978-1-61254-672-8"), _c('br'), _vm._v("LCCN 2024943445")])]), _vm._v(" "), _c('p', {
    staticClass: "CC"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Printed in the United States")])]), _vm._v(" "), _c('p', {
    staticClass: "CC0"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")])]), _vm._v(" "), _c('p', {
    staticClass: "CC _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("For more information or to contact the author, please go to "), _c('a', {
    attrs: {
      "href": "http://www.BrownBooksKids.com",
      "target": "_blank"
    }
  }, [_vm._v("www.BrownBooksKids.com")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39850b9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04-copy.vue
// module id = 66
// module chunks = 0